import { render, staticRenderFns } from "./terms-of-use.vue?vue&type=template&id=07dca1a8"
import script from "./terms-of-use.vue?vue&type=script&lang=js"
export * from "./terms-of-use.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports